module.exports = __webpack_public_path__ + "static/media/thumbnail.6eec1bd0.jpg";